import { sub } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';

export function addUtcOffset(date: Date) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = getTimezoneOffset(timezone, date);
  return sub(date, {
    seconds: offset / 1000,
  });
}
